<template>
  <div>
    <h2>Account - Team</h2>
    <p>Manage your team!</p>
    <br />
    <vs-tabs>
      <vs-tab label="Users">
        <div id="usersTab" class="tab">
          <!-- Users -->
          <vs-button v-if="loading === 0" class="add-button" @click.native="editUser()" color="warning" type="filled">Add User</vs-button>
          <vs-table
            v-if="users.length >=1 && loading === 0"
            v-model="selected_users"
            :data="users"
            max-items="15"
            pagination
            hoverFlat
            search
          >
            <template slot="header">
              <h3>
                Users
              </h3>
            </template>
            <template slot="thead">
              <vs-th>
                Name
              </vs-th>
              <vs-th>
                Email
              </vs-th>
              <vs-th>
                Groups
              </vs-th>
              <vs-th />
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="user" :key="user.user_id" v-for="user in data">
                <vs-td :data="user.name">
                  {{user.name}}
                </vs-td>
                <vs-td :data="user.email">
                  {{user.email}}
                </vs-td>
                <vs-td :data="user.app_metadata.authorization.groups">
                  <vs-chip
                    v-for="group in user.app_metadata.authorization.groups"
                    :key="group" v-if="user.app_metadata.authorization.groups.length >= 1"
                    transparent
                  >
                    {{group}}
                  </vs-chip>
                  <span v-if="user.app_metadata.authorization.groups.length <=0" class="userGroup">
                    No groups
                  </span>
                </vs-td>
                <vs-td>
                  <vs-row vs-justify="flex-end" class="flex-no-wrap">
                    <vs-button radius class="mr-1" color="warning" type="filled" icon="edit" @click.native="editUser(user)"></vs-button>
                    <vs-button radius color="danger" type="filled" icon="delete" @click.native="confirmDialog(user)"></vs-button>
                  </vs-row>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <vs-popup
          classContent="add-user-popup"
          :title="(add_user_given_name === '' && add_user_family_name === '') ? 'Add/Invite a User' : `Editing ${add_user_given_name} ${add_user_family_name}`"
          :active.sync="saveUserPopup"
        >
          <vs-input
            name="first name"
            label-placeholder="First Name"
            v-model="add_user_given_name"
            v-validate="'required'"
            data-vv-validate-on="blur"
            :warning="errors.has('first name')"
            :warning-text="errors.first('first name')"
            size="large"
          />
          <vs-input
            name="last name"
            label-placeholder="Last Name"
            v-model="add_user_family_name"
            v-validate="'required'"
            data-vv-validate-on="blur"
            :warning="errors.has('last name')"
            :warning-text="errors.first('last name')"
            size="large"
          />
          <vs-input
            name="email"
            label-placeholder="Email"
            v-model="add_user_email"
            v-validate="'required|email'"
            data-vv-validate-on="blur"
            :warning="errors.has('email')"
            :warning-text="errors.first('email')"
            size="large"
          />
          <vs-select
            name="groups"
            label="Groups"
            multiple
            autocomplete
            v-model="add_user_groups"
          >
            <vs-select-item :key="item.name" :value="item.name" :text="item.name" v-for="item in groups" />
          </vs-select>
          <vs-row vs-justify="flex-end" class="mt-12">
            <vs-button @click="saveUser" color="primary" type="filled" :disabled="!isUserFormValid">Save</vs-button>
          </vs-row>
        </vs-popup>
      </vs-tab>
      <vs-tab label="Groups">
        <div id="groupsTab" class="tab">
          <vs-button v-if="loading === 0" @click="editGroup()" color="warning" class="add-button" small type="filled">Add Group</vs-button>
          <vs-table
            v-if="groups.length >=1 && loading === 0"
            v-model="selected_groups"
            :data="groups"
            max-items="15"
            pagination
            hoverFlat
            search
          >
            <template slot="header">
              <h3>
                Groups
              </h3>
            </template>
            <template slot="thead">
              <vs-th>
                Name
              </vs-th>
              <vs-th>
                Description
              </vs-th>
              <vs-th>
                Member Count
              </vs-th>
              <vs-th />
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="group" :key="group.name" v-for="group in data" style="cursor: pointer;">
                <vs-td :data="group.name">
                  {{group.name}}
                </vs-td>
                <vs-td>
                  {{group.description}}
                </vs-td>
                <vs-td>
                  {{group.count}}
                </vs-td>
                <vs-td>
                  <vs-row vs-justify="flex-end" class="flex-no-wrap">
                    <vs-button radius class="mr-1" color="warning" type="filled" icon="edit" @click.native="editGroup(group)"></vs-button>
                    <vs-button radius color="danger" type="filled" icon="delete" @click.native="confirmDialog(group)"></vs-button>
                  </vs-row>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <vs-popup
            classContent="add-group-popup"
            :title="add_group_name ? ` Edit ${add_group_name}` : 'Create a group!'" :active.sync="saveGroupPopup"
          >
            <vs-input
              name="name"
              label-placeholder="Name"
              v-model="add_group_name"
              v-validate="'required'"
              v-if="add_group_editing === false"
              data-vv-validate-on="blur"
              :warning="errors.has('name')"
              :warning-text="errors.first('name')"
              size="large"
            />
            <vs-input
              name="description"
              label-placeholder="Description"
              v-model="add_group_description"
              v-validate="'required'"
              data-vv-validate-on="blur"
              :warning="errors.has('description')"
              :warning-text="errors.first('description')"
              size="large"
            />
            <vs-row vs-justify="flex-end" class="mt-12">
              <vs-button @click="saveGroup" color="primary" type="filled" :disabled="!isGroupFormValid">Save</vs-button>
            </vs-row>
          </vs-popup>
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
export default {
  data () {
    return {
      users: [],
      groups: [],
      add_user_given_name: '',
      add_user_family_name: '',
      add_user_email: '',
      add_user_groups: [],
      add_user_id: '',
      add_group_name: '',
      add_group_description: '',
      add_group_users: [],
      add_group_editing: false,
      saveUserPopup: false,
      deleteUserPopup: false,
      saveGroupPopup: false,
      selected_users: [],
      selected_groups: [],
      loading: 0
    }
  },
  computed: {
    isUserFormValid () {
      const $this = this

      if ($this.errors.any()) {
        return false
      }
      if ($this.add_user_given_name === '' || $this.add_user_family_name === '' || $this.add_user_email === '') {
        return false
      }
      return true
    },
    isGroupFormValid () {
      const $this = this

      if ($this.errors.any()) {
        return false
      }
      if ($this.add_group_description === '' || $this.add_group_name === '') {
        return false
      }
      return true
    }
  },
  watch: {
    id: {
      immediate: true,
      handler () {
        this.loadData()
      }
    }
  },
  methods: {
    tabClicked () {
    },
    resourcesEmpty () {
      return this.users.length <= 0 && this.groups.length <= 0
    },
    getResources () {
      const $this = this
      $this.loading++
      this.$http
        .get(`${process.env.VUE_APP_API_ENDPOINT}/team/user`, {
          headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
        }).then(response => {
          $this.users = response.data
          this.$http
            .get(`${process.env.VUE_APP_API_ENDPOINT}/team/group`, {
              headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
            }).then(response => {
              $this.groups = response.data
              $this.loading--
            })
        })
    },
    saveUser () {
      const $this = this
      const groups = {
        groups: this.add_user_groups
      }
      const id = $this.add_user_id
      const data = {
        given_name: this.add_user_given_name,
        family_name: this.add_user_family_name,
        email: this.add_user_email
      }

      $this.loading++

      // if user already exists, update their info
      if ($this.users.some(user => user.user_id === id)) {

        // save user name / email
        this.$http
          .put(`${process.env.VUE_APP_API_ENDPOINT}/team/user/${id}`, data, {
            headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
          }).then(() => {
            this.$vs.notify({
              title:'User Updated!',
              text: 'The user has been updated',
              color: 'success'
            })

            this.$http
              .put(`${process.env.VUE_APP_API_ENDPOINT}/team/user/${id}/groups`, groups, {
                headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
              }).then(() => {
                $this.getResources()
                $this.loading--
                $this.saveUserPopup = false
              }).catch(err => {
                this.$vs.notify({
                  title:'Uh Oh!',
                  text: err.response.data.message,
                  color:'warning'
                })
                $this.loading--
              })
          }).catch(err => {
            this.$vs.notify({
              title:'Uh Oh!',
              text: err.response.data.message,
              color:'warning'
            })
            $this.loading--
          })
      } else {
        data.groups = $this.add_user_groups
        this.$http
          .post(`${process.env.VUE_APP_API_ENDPOINT}/team/user`, data, {
            headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
          }).then(() => {
            this.$vs.notify({
              title:'User Invited!',
              text: 'The user has been invited',
              color: 'success'
            })
            $this.getResources()
            $this.loading--
            $this.saveUserPopup = false
          }).catch(err => {
            this.$vs.notify({
              title:'Uh Oh!',
              text: err.response.data.message,
              color:'warning'
            })
            $this.loading--
          })
      }
    },
    editUser (user) {
      const $this = this
      $this.add_user_given_name = ''
      $this.add_user_family_name = ''
      $this.add_user_email = ''
      $this.add_user_groups = []
      $this.add_user_id = ''
      if (user) {
        $this.add_user_given_name = user.given_name
        $this.add_user_family_name = user.family_name
        $this.add_user_email = user.email
        $this.add_user_groups = user.app_metadata.authorization.groups
        $this.add_user_id = user.user_id
      }
      $this.saveUserPopup = true
    },
    deleteUser (user) {
      const $this = this
      const id = user.user_id

      // make sure user exists, then delete them
      if ($this.users.some(user => user.user_id === id)) {
        $this.loading++
        $this.$http
          .delete(`${process.env.VUE_APP_API_ENDPOINT}/team/user/${id}`, {
            headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
          }).then(() => {
            $this.$vs.notify({
              title:'User Removed!',
              text: 'The user has been removed from your the team',
              color: 'success'
            })
            $this.loading--
            $this.getResources()
          }).catch(err => {
            $this.$vs.notify({
              title:'Uh Oh!',
              text: err.response.data.message,
              color:'warning'
            })
            $this.loading--
          })
      } else {
        $this.$vs.notify({
          title:'Uh Oh!',
          text: 'There was an error removing this user.',
          color:'warning'
        })
      }
    },
    saveGroup () {
      const $this = this
      const name = $this.add_group_name
      $this.loading++

      // if group already exists, update their info
      if ($this.groups.some(group => group.name === name)) {
        const data = {
          description: $this.add_group_description
        }
        this.$http
          .put(`${process.env.VUE_APP_API_ENDPOINT}/team/group/${name}`, data, {
            headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
          }).then(() => {
            this.$vs.notify({
              title:'Group Updated!',
              text: 'The group has been updated',
              color: 'success'
            })
            $this.getResources()
            $this.loading--
            $this.saveGroupPopup = false
          }).catch(err => {
            this.$vs.notify({
              title:'Uh Oh!',
              text: err.response.data.message,
              color:'warning'
            })
            $this.saveGroupPopup = false
            $this.loading--
          })
      } else {
        const data = {
          name,
          description: $this.add_group_description
        }
        this.$http
          .post(`${process.env.VUE_APP_API_ENDPOINT}/team/group`, data, {
            headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
          }).then(() => {
            this.$vs.notify({
              title:'Group Created!',
              text: 'The team has been created.',
              color: 'success'
            })
            $this.getResources()
            $this.loading--
            $this.saveGroupPopup = false
          }).catch(err => {
            this.$vs.notify({
              title:'Uh Oh!',
              text: err.response.data.message,
              color:'warning'
            })
            $this.saveGroupPopup = false
            $this.loading--
          })
      }
    },
    editGroup (group) {
      const $this = this
      if (group) {
        $this.add_group_name = group.name
        $this.add_group_description = group.description
        $this.add_group_users = group.users
        $this.add_group_editing = true
      } else {
        $this.add_group_name = ''
        $this.add_group_description = ''
        $this.add_group_users = []
        $this.add_group_editing = false
      }
      $this.saveGroupPopup = true
    },
    deleteGroup (group) {
      const $this = this
      const name = group.name

      // make sure group exists, then delete
      if ($this.groups.some(group => group.name === name)) {
        $this.loading++
        $this.$http
          .delete(`${process.env.VUE_APP_API_ENDPOINT}/team/group/${name}`, {
            headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
          }).then(() => {
            $this.$vs.notify({
              title:'Group Removed!',
              text: 'The group has been removed from your account',
              color: 'success'
            })
            $this.getResources()
            $this.loading--
          }).catch(err => {
            $this.$vs.notify({
              title:'Uh Oh!',
              text: err.response.data.message,
              color:'warning'
            })
            $this.loading--
          })
      } else {
        $this.$vs.notify({
          title:'Uh Oh!',
          text: 'There was an error removing this group.',
          color:'warning'
        })
      }
    },
    loadData () {
      this.users = []
      this.groups = []
      this.getResources()
    },
    confirmDialog (userOrGroup) {
      const $this = this
      const isUser = userOrGroup.hasOwnProperty('user_id')
      const user = userOrGroup
      const group = userOrGroup

      if (isUser) {
        $this.$vs.dialog({
          title: 'Just checking...',
          text: `Are you sure you want to delete ${user.given_name} ${user.family_name}?`,
          parameters: user,
          accept: $this.deleteUser
        })
      } else {
        $this.$vs.dialog({
          title: 'Just checking...',
          text: `Are you sure you want to delete ${group.name}?`,
          parameters: group,
          accept: $this.deleteGroup
        })
      }
    }
  },
  created () {
    this.loadData()
  }
}

</script>

<style lang="scss">
.tab {
  margin-top: 15px;
}
.vs-tabs--btn {
  font-size: 17px !important;
}
.vs-table--tbody-table
.tr-values.hoverFlat:not(.activeEdit):not(.is-expand):hover
.vs-button {
    opacity: 1;
    z-index: 18;
}
.vs-table--tbody-table
.tr-values.hoverFlat:not(.activeEdit):not(.is-expand)
.vs-button {
    opacity: 0;
}
.add-button {
  float: right;
  top: 12px;
  margin-left: 10px;
}
.is-selected .con-vs-chip {
    background: rgba(var(--vs-primary),.1);
    color: rgba(var(--vs-primary),1);
    border: 1px solid rgba(var(--vs-primary),1);
}
</style>
